import styled from 'styled-components'

import { LimitOrderPrices } from '../../common/limit-order-prices'
import { LimitOrderSettings } from '../../common/limit-order-settings'
import { LimitOrderSize } from '../../common/limit-order-size'

import type { LimitOrderModel } from '../../../atoms'

type Props = {
  order: LimitOrderModel
}

export const LimitOrderItemPair: React.FC<Props> = ({ order }) => {
  // TODO: use reatomTradingPair to get actual price
  const { pair } = order

  return (
    <Root>
      <LimitOrderSize order={order} showSizeEquivalent />
      <Columns>
        <LimitOrderPrices pair={pair} />
        <LimitOrderSettings order={order} />
      </Columns>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`

const Columns = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 4px;
`
